import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100 px-4">
      
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-2xl rounded-3xl p-8 max-w-md w-full text-center border"
      >
        
        {/* 🚀 Icon */}
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="text-5xl mb-4"
        >
          🚧
        </motion.div>

        {/* 🧠 Title */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Coming Soon
        </h1>

        {/* 📄 Subtitle */}
        <p className="text-gray-500 text-sm mb-6">
          This page isn’t ready yet, but your navigation is working perfectly.
          We’re building something awesome here 👨‍💻
        </p>

        {/* ⚡ Actions */}
        <div className="flex gap-3 justify-center">
          
          <button
            onClick={() => navigate("/")}
            className="px-5 py-2 rounded-xl bg-[#01c37d] text-white font-semibold hover:scale-105 transition"
          >
            Go Home
          </button>

          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2 rounded-xl border text-gray-700 hover:bg-gray-100 transition"
          >
            Retry
          </button>

        </div>

        {/* 🧩 Footer hint */}
        <div className="mt-6 text-xs text-gray-400">
          Error Code: 404_NOT_FOUND
        </div>
      </motion.div>
    </div>
  );
}